import React from 'react';
import StrapiRichText from 'strapi/components/StrapiRichText';
import { BlockComponentProps } from 'strapi/types/utils';

import styles from './TextBlock.module.scss';

export const TextBlock = ({
  block,
}: BlockComponentProps<'marketing-website.text-block'>) => (
  <section className={`p-body mt56 text-block-container ${styles.container}`}>
    <StrapiRichText richText={block.paragraph} />
  </section>
);
